import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import DashboardLayout from "src/components/layout/dashboard/Layout";
import PageHeader from "src/components/common/PageHeader";
import Card from "src/components/common/card/Card";
import Tabs from "src/components/ui/Tabs";
import TenantRoleForm from "src/components/forms/TenantRoleForm";

import { useAppSelector } from "src/redux/hooks";

const CreateEditRolePage: React.FC = () => {
  const basePath = "/app/team-management";
  const navigate = useNavigate();
  const { tenantRoleId } = useParams();
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);

  const isTenantAdmin =
    user?.role === "admin" ||
    user?.roleDetails?.name?.toLowerCase() === "admin";

  if (!isTenantAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <DashboardLayout
      meta={{
        title: `${tenantRoleId ? "Edit" : "Create"} Role | Invyntra`,
        description: "Manage roles and permissions for your workspace.",
      }}
    >
      <div className="space-y-4">
        <PageHeader
          title={tenantRoleId ? "Edit Role" : "Create Role"}
          breadcrumbData={[
            { label: "Home", path: "/app/dashboard" },
            { label: "Team management", path: `${basePath}/role-list` },
            {
              label: tenantRoleId ? "Edit Role" : "Create Role",
              path: tenantRoleId
                ? `${basePath}/role/${tenantRoleId}/edit`
                : `${basePath}/role/create`,
            },
          ]}
        />

        <Card>
          <Tabs
            tabs={[
              { label: "Users", value: "users" },
              { label: "Roles", value: "roles" },
            ]}
            activeTab="roles"
            onChange={(value) =>
              navigate(
                `${basePath}/${value === "roles" ? "role-list" : "user-list"}`
              )
            }
            className="flex gap-2 border-b border-gray-200"
          />

          <div className="pt-4">
            <TenantRoleForm
              tenantRoleId={tenantRoleId}
              onCancel={() => navigate(`${basePath}/role-list`)}
              onSuccess={() => navigate(`${basePath}/role-list`)}
            />
          </div>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default CreateEditRolePage;
